import React from 'react';

const brands = [
  { name: 'Whirlpool', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1c/Whirlpool_Corporation_Logo.svg' },
  { name: 'Samsung', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg' },
  { name: 'LG', logo: 'https://upload.wikimedia.org/wikipedia/commons/b/bf/LG_logo_%282015%29.svg' },
  { name: 'GE', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/18/General_Electric_logo.svg' },
  { name: 'Maytag', logo: 'https://upload.wikimedia.org/wikipedia/commons/8/87/Maytag_brand_logo.png' },
  { name: 'KitchenAid', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fe/KitchenAid_logo.svg' },
];

const BrandsSection = () => {
  return (
    <section data-testid="brands-section" className="py-16 bg-white border-y border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl font-semibold text-foreground">
            We Service Most Major Brands
          </h2>
          <p className="text-muted-foreground mt-2">
            Whirlpool, Samsung, Maytag, Kenmore, Amana, Admiral, LG, GE, and many more
          </p>
        </div>
        
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
          {brands.map((brand, index) => (
            <div
              key={brand.name}
              data-testid={`brand-${brand.name.toLowerCase()}`}
              className="brand-logo flex items-center justify-center h-12 w-24 md:w-32"
            >
              <span className="text-xl font-bold text-gray-400 hover:text-gray-700 transition-colors">
                {brand.name}
              </span>
            </div>
          ))}
          <div className="text-lg font-medium text-primary">
            + Many More
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
